export default "__VITE_ASSET__B5Heht2a__"